<template>
  <Esi :src="commonFooterUrl" />
</template>

<script>
import Esi from '../Utilities/Esi.vue'

export default {
  data() {
    return {
      commonFooterUrl:
        'serum/render?id=1.7662766&amp;size=18&amp;perspective=RICH&amp;alignment=RIGHT&amp;created=1446130322000'
    }
  },
  components: {
    Esi
  }
}
</script>

<style scoped>
</style>
